import React, {Component} from 'react';
import Main from '../Main';
import moment from 'moment';
import {bindActionCreators} from "redux";
import {
    setLoadingGetIssues,
    getIssues,
    getIssuesSuccess,
    getIssuesError,
    setLoadingDeleteIssue,
    deleteIssue,
    deleteIssueSuccess,
    deleteIssueError,
    toggleEditIssueModal
} from '../../actions/IssueActions';
import {connect} from "react-redux";
import ReactPaginate from 'react-paginate';
import EditIssueModal from '../IssueManagement/EditIssueModal';
import { TRANSLATE_NUMBER_OF_SHOWN_ISSUES, TRANSLATE_QUESTION_DELETE_ISSUE } from '../../translates/Translates';
import {Link} from 'react-router-dom';

class Tier3 extends Component{
    constructor(props){
        super(props);

        this.state = {
            issues: [],
            filter_ids: [],
            filter_processes: [],
            issueId: '',
            page: 1,
            number_of_pages: 0,
            number_of_issues: 0
        }
    }

    componentDidMount(){
        this.props.setLoadingGetIssues();
        this.props.getIssues(this.state.page, this.state.filter_ids, this.state.filter_processes)
        .then((response) => {
            this.setState(
                {
                    issues: response.payload.data.issues, 
                    number_of_pages: response.payload.data.number_of_pages,
                    number_of_issues: response.payload.data.number_of_issues
                }
            )
            this.props.getIssuesSuccess();
        })
        .catch(() => {
            this.props.getIssuesError();
        })
    }
 
    getContentIssueNameByType(process){
        return(<span className="badge badge-warning">{process.name}</span>);
        /*if(process.id === 1){
            return(<span className="badge badge-warning">{process.name}</span>);
        }else if(process.id === 2){
            return(<span className="badge badge-success">{process.name}</span>);
        }else if(process.id === 3){
            return(<span className="badge badge-danger">{process.name}</span>);
        }else if(process.id === 4){
            return(<span className="badge badge-info">{process.name}</span>);
        }*/
    }

    getContentStatus(status){
        if(status.id === 1){
            return(<span className="badge badge-success">{status.name}</span>);
        }else if(status.id === 2){
            return(<span className="badge badge-danger">{status.name}</span>);
        }
    }

    handleClickDeleteElement(id){
        if(window.confirm(TRANSLATE_QUESTION_DELETE_ISSUE)){
            this.props.setLoadingDeleteIssue();
            this.props.deleteIssue(id)
            .then(() => {
                this.props.deleteIssueSuccess();
            }).catch(() => {
                this.props.deleteIssueError();
            })
        }
    }

    handleClickOpenModalEditIssue(id){
        this.props.toggleEditIssueModal(true, false);
        this.setState({issueId: id});
    }

    handleClickPage = (page) => {
        let real_page = (page.selected*1) + 1;
        this.setState({page: real_page});
        this.props.setLoadingGetIssues();
        this.props.getIssues(real_page, this.state.filter_ids, this.state.filter_processes).then((response) => {
            this.setState(
                {
                    issues: response.payload.data.issues, 
                    number_of_pages: response.payload.data.number_of_pages, 
                    number_of_issues: response.payload.data.number_of_issues
                }
            );
            this.props.getIssuesSuccess();
        }).catch(() => {
            this.props.getIssuesError();
        }) 
    }

    render(){
        return(
            <div>
                {this.props.editIssueModalOpened ? (
                    <EditIssueModal issueId={this.state.issueId} />
                ) : null }
                <Main />
                <div className="page-wrapper">
                    <div className="container-fluid">
                        <br />
                        <div className="row page-tier3">
                            <div className="col s12">
                                <div className="card card-outline-info">
                                    <div className="card-header">
                                        <h4 className="mb-0 text-white">Tier 3</h4>
                                    </div>
                                    <div className="card-body">
                                        <div className="table-responsive table-tier3">
                                            <table className="table striped mb-3 mt-4 no-wrap" id="editable-datatable">
                                                <thead>
                                                    <tr>
                                                        <th></th>
                                                        <th>ID</th>
                                                        <th>Process</th>
                                                        <th>Line</th>
                                                        <th>Operation</th>
                                                        <th>When open</th>
                                                        <th>When close</th>
                                                        <th>Product</th>
                                                        <th>Class</th>
                                                        <th>Line type</th>
                                                        <th>Status</th>
                                                        <th>Who</th>
                                                        <th>Issue origin</th>
                                                        <th>Problem category</th>
                                                        <th>Failure MODE</th>
                                                        <th>Failure CAUSE</th>
                                                        <th>Failure EFFECT</th>
                                                        <th>Detection</th>
                                                    </tr>
                                                </thead>
                                                <tbody id="tier3-body">
                                                    {this.state.issues.map((element, index) => {
                                                        return(
                                                            <tr id={element.id} key={index} data-id={element.id} data-parent-id={element.parent_id ? element.parent_id : null} className="gradeX">
                                                                <td className="center-right"> 
                                                                        {element.parent_id === 0 ? (
                                                                            <i className="fas fa-minus"></i>
                                                                        ) : null}
                                                                        <i className="fas fa-plus"></i>
                                                                    <button type="button" className="tier3-body__element-edit" onClick={() => this.handleClickOpenModalEditIssue(element.id)}>
                                                                        <i className="fas fa-pencil-alt"></i>
                                                                    </button>
                                                                    <button type="button" onClick={() => this.handleClickDeleteElement(element.id)} className="tier3-body__element-delete">
                                                                        <i className="ti-close-td fas fa-times"></i>
                                                                    </button>
                                                                </td>
                                                                <td className="center-right">{element.id}</td>
                                                                <td>{element.process ? this.getContentIssueNameByType(element.process) : null}</td>
                                                                <td className="center">{element.line ? element.line.name : null}</td>
                                                                <td className="center-right">{element.operation ? element.operation.name : null}</td>
                                                                <td className="center">{element.when_start ? moment.unix(element.when_start).format("DD.MM.YYYY") : null}</td>
                                                                <td className="center">{element.when_close ? moment.unix(element.when_close).format("DD.MM.YYYY") : null}</td>
                                                                <td className="center">{element.product ? element.product.name : null}</td>
                                                                <td className="center-right">{element.class ? element.class.name : null}</td>
                                                                <td className="center">{element.line_type_select ? element.line_type_select.name : null}</td>
                                                                <td>{element.status_select ? this.getContentStatus(element.status_select) : null}</td>
                                                                <td><Link to="/" className="user-link">{element.who_select ? element.who_select.name : null}</Link></td>
                                                                <td>{element.issue_origin ? element.issue_origin.name : null}</td>
                                                                <td className="center">{element.problem_category ? element.problem_category.name : null}</td>
                                                                <td className="center failure-mode-td">{element.failure_mode}</td>
                                                                <td className="center failure-cause-td">{element.failure_cause}</td>
                                                                <td className="center failure-effect-td">{element.failure_effect}</td>
                                                                <td className="center detection-td">{element.detection}</td>
                                                                }
                                                            </tr>
                                                        )
                                                    })}   
                                                </tbody>
                                            </table>
                                        </div>
                                        <div className="page-isssues__number-shown-issues">
                                            <p>{TRANSLATE_NUMBER_OF_SHOWN_ISSUES + ": " + this.state.number_of_issues}</p>
                                        </div>
                                        <div>
                                            <ReactPaginate
                                                pageCount={this.state.number_of_pages}
                                                pageRangeDisplayed={4}
                                                marginPagesDisplayed={1}
                                                previousLabel={<i className="fas fa-chevron-left"></i>}
                                                nextLabel={<i className="fas fa-chevron-right"></i>}
                                                onPageChange={this.handleClickPage}
                                                containerClassName="pagination-container"
                                                pageClassName="pagination-page"
                                                pageLinkClassName="pagination-page-link"
                                                activeClassName="pagination-page-active"
                                                previousClassName="pagination-previous"
                                                nextClassName="pagination-next"
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        editIssueModalOpened: state.issueReducer.editIssueModalOpened
    }
}

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({
        getIssues,
        setLoadingGetIssues,
        getIssuesSuccess,
        getIssuesError,
        setLoadingDeleteIssue,
        deleteIssue,
        deleteIssueSuccess,
        deleteIssueError,
        toggleEditIssueModal
    }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(Tier3);
